import React, {PureComponent, ReactNode} from "react"
import styled from "styled-components"
import {Grid} from "react-bootstrap"

import Card from "@irati/ui/src/Layout/Card"
import {H2} from "@irati/ui/src/Typography"
import StepIndicator from "@irati/ui/src/StepIndicator"
import {FormattedMessage} from "@irati/utils/lang"
import {minWidthMedia} from "@irati/ui/src/global/media"

import doctorCareAnywhere from "../../images/doctorCareAnywhere.svg"

const STEPS_COUNT = 3

const StyledGrid = styled(Grid)`padding-top: 30px;`

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
  min-height: 130px;
  ${minWidthMedia.tablet`
    flex-direction: row;
    min-height: auto;
  `}
`

const Logo = styled.img`
  display: block;
  margin: 30px auto 0;
  width: 125px;
`

const NoPaddingBottomCard = styled(Card)`
  overflow: hidden;
  padding-bottom: 20px;
  ${minWidthMedia.tablet`
    padding-bottom: 0;
  `}
`

interface Props {
  currentStep: number,
  noPaddingBottom: boolean,
  children: ReactNode
}

class StepPage extends PureComponent<Props> {
  render() {
    const {currentStep, noPaddingBottom, children} = this.props
    const MainContentCard = noPaddingBottom ? NoPaddingBottomCard : Card
    return (
      <StyledGrid>
        <StyledCard>
          <H2><FormattedMessage id="medical.landing.steps.header" /></H2>
          <StepIndicator stepsCount={STEPS_COUNT} currentStep={currentStep} />
        </StyledCard>
        <MainContentCard>{children}</MainContentCard>
        <Logo src={doctorCareAnywhere} />
      </StyledGrid>
    )
  }
}

export default StepPage
